import React, { Component } from "react";
import axios from "axios"; // Import Axios
import logo from "../../img/shopperr_logo.png";
import CommonFunctions from "../../global/CommonFunctions";
import { Link } from "react-router-dom";

class HeaderSearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: props.search.keyword ?? "",
      category: props.search.category ?? "search",
      categories: [], 
    };
  }

  // Fetch categories when the component mounts
  async componentDidMount() {
    try {
      // Call the backend API to fetch categories
      const response = await axios.get(`${process.env.REACT_APP_NODE_API_URL}`+'/shopperrds/getwebsiteCategories');
      if (response.data.success) {
        this.state.keyword = '';
        this.setState({ categories: response.data.data });
      } else {
        console.error("Failed to fetch categories:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching categories:", error.message);
    }
  }

  searchProducts(e) {
    this.setState({ keyword: CommonFunctions.getValidURLCategory(e.target.value) });
    if (e.key === "Enter") {
      this.onSearch(e);
    }
  }

  onSearch(e, category) {
    //console.log(category)
    e.preventDefault();

    window.location.href = `/${category ?? this.state.category}/${
      this.state.keyword
    }`; 
    //window.location.href = url.replace(/\/\//g, '/');
  }
  
  

  render() {
    return (
      <div className="header-container container-fluid">
        <div className="header-row py-2">
          <div className="header-column w-100">
            <div className="header-row">
              <div className="header-logo z-index-2 col-lg-4 px-0">
                <Link to="/">
                  <img
                    alt="Shopperr"
                    className="ShopperrLogo"
                    data-sticky-width="82"
                    data-sticky-height="40"
                    data-sticky-top="84"
                    src={logo}
                  />
                </Link>
              </div>
              <div className="header-nav-features header-nav-features-no-border col-lg-5 col-xl-6 px-0 ms-0">
                <div className="header-nav-feature">
                  <form role="search">
                    <div className="search-with-select">
                      <a
                        className="mobile-search-toggle-btn me-2"
                        data-porto-toggle-class="open"
                      >
                        <i className="icons icon-magnifier text-color-dark text-color-hover-primary"></i>
                      </a>
                      <div className="search-form-wrapper input-group">
                        <input
                          className="form-control text-1"
                          name="q"
                          type="text"
                          placeholder="Search..."
                          onInput={this.searchProducts.bind(this)}
                        />
                        <div className="search-form-select-wrapper">
                          <div className="custom-select-1">
                            <select
                              name="category"
                              className="form-control form-select"
                              onChange={(e) => {
                                this.setState({
                                  category: CommonFunctions.getValidURLCategory(
                                    e.target.value
                                  ),
                                });
                                this.onSearch(
                                  e,
                                  CommonFunctions.getValidURLCategory(e.target.value)
                                );
                              }}
                              value={this.state.category}
                            >
                              <option value="search">All Categories</option>
                              {this.state.categories.map((item, key) => {
                                return (
                                  <option
                                    value={CommonFunctions.getValidURLCategory(
                                      item.uri
                                    )}
                                    key={item._id}
                                  >
                                    {item.name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <button
                            className="btn"
                            type="submit"
                            onClick={this.onSearch.bind(this)}
                          >
                            <i className="icons icon-magnifier header-nav-top-icon"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderSearchBar;
